// extracted by mini-css-extract-plugin
export default {"status":"status__WNh4z","border":"border__hm1pU","inline":"inline__pLlUe","sectionTitle":"sectionTitle__O_xUc"};